cms-popover {
  --offset: 15px;
  position: relative;
  [data-slot='reference-element'] {
    cursor: pointer;
  }
  [data-slot='floating-element'] {
    display: none;
    box-sizing: border-box;
    box-shadow: 0px 2px 8px rgba(106, 115, 129, 0.12);
    width: 318px;
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    color: #333;
    padding: 16px 0px;
    border-radius: 16px;
    border: solid 1px #ccc;
    z-index: 500;
    font-size: 16px;
    line-height: 1.71;
    max-width: calc(100vw - 10px);
    [data-slot='title'] {
      margin: 0px;
      padding: 0px 24px;
      font-weight: 700;
      font-size: 20px;
    }
    [data-slot='content'] {
      padding: 0px 24px;
      font-weight: 400;
      & > p {
        margin: 5px 0px;
      }
    }
    [data-slot='actions'] {
      padding: 5px 16px 0px;
      a {
        color: #126cc5;
        font-weight: 400;
        font-size: 16px;
        text-decoration: none;
        margin: 0px 8px;
        &:hover {
          text-decoration: underline;
        }
      }
    }

    div[data-slot='arrow'] {
      position: absolute;
      background-color: transparent;
      width: 14px;
      height: 14px;
      &::before {
        position: absolute;
        background: #fff;
        content: ' ';
        width: 14px;
        height: 14px;
        transform: rotate(45deg);
        border: solid 1px #ccc;
        border-radius: 4px;
      }
      &::after {
        content: ' ';
        position: absolute;
        background-color: #fff;
      }
      &[data-arrow-direction='bottom'] {
        &::after {
          width: 20px;
          height: 11px;
          left: -25%;
          bottom: 50%;
        }
      }
      &[data-arrow-direction='top'] {
        &::after {
          width: 20px;
          height: 11px;
          left: -25%;
          top: 50%;
        }
      }
      &[data-arrow-direction='left'] {
        &::after {
          width: 11px;
          height: 20px;
          bottom: -25%;
          left: 50%;
        }
      }
      &[data-arrow-direction='right'] {
        &::after {
          width: 11px;
          height: 20px;
          top: -25%;
          right: 50%;
        }
      }
    }
    &::before {
      content: ' ';
      background-color: transparent;
      position: absolute;
    }
    &[data-arrow-direction='bottom'] {
      &::before {
        width: 100%;
        height: calc(var(--offset));
        bottom: calc(0px - var(--offset));
        left: 0px;
      }
    }
    &[data-arrow-direction='top'] {
      &::before {
        width: 100%;
        height: calc(var(--offset));
        top: calc(0px - var(--offset));
        left: 0px;
      }
    }
    &[data-arrow-direction='left'] {
      &::before {
        height: 100%;
        width: calc(var(--offset));
        left: calc(0px - var(--offset));
        top: 0px;
      }
    }
    &[data-arrow-direction='right'] {
      &::before {
        height: 100%;
        width: calc(var(--offset));
        right: calc(0px - var(--offset));
        top: 0px;
      }
    }
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  [data-slot='reference-element']:focus-visible {
    outline: 2px solid #4299e1;
    outline-offset: 2px;
  }

  [data-slot='floating-element']:focus-visible {
    outline: none;
  }
}
